module.exports = __webpack_public_path__ + "img/hc_main.c821a378.png";